import makeActionCreator from './makeActionCreator';
import {
  TRANSFER_OWNER,
  TRANSFER_OWNER_DONE,
  TRANSFER_OWNER_ERROR,
  TRANSFER_OWNER_LOADING,
  TRANSFER_OWNER_SUCCESS
} from './actionTypes';

export const transferOwner = makeActionCreator(TRANSFER_OWNER, 'tenantId', 'email');
export const transferOwnerLoading = makeActionCreator(TRANSFER_OWNER_LOADING);
export const transferOwnerSuccess = makeActionCreator(TRANSFER_OWNER_SUCCESS, 'tenant');
export const transferOwnerError = makeActionCreator(TRANSFER_OWNER_ERROR, 'error');
export const transferOwnerDone = makeActionCreator(TRANSFER_OWNER_DONE);
